import {User} from "./user";
import {Project} from "./project";
import {ColDef, ColType, ListEntry} from "./colDef";
import {ProjectRole} from "./projectRole";

export enum ProjectAssignmentStatus{
  INACTIVE = 0,
  ACTIVE = 1,
  PENDING = 2
}

export interface MemberAssignment {
  id?: number,
  start_on?: Date|string,
  end_on?: Date|string,
  dedication: number,
  status: ProjectAssignmentStatus,
  user?: User,
  project_role?: ProjectRole,
  projectRole_id?: number,
  cost?: number,
  offered?: number,
  project?: Project,
  description?: string,
  comment?: string,
  invited_at?: Date|string,
  reviewed_at?: Date|string,
  invite_rejected?: boolean,
  Phase_id?: number,

  Client_id?: number,
  client?: string,
  title?: string,
  role?: string,
  location?: string
}

export interface MemberAssignmentForm{
  Phase_id: number,
  timeline: {start: Date, end: Date},
  dedication: number,
  status: ProjectAssignmentStatus,
  offered: number,
  cost: number,
  ProjectRole_id: number,
  description: string,
  project?: ListEntry
}

export interface PhaseAssignmentForm{
  Phase_id: number
}

export const memberAssignmentColDefs: ColDef[] = [
  {
    title: 'Project phase',
    subtitle: 'Enter phase',
    name: 'Phase_id',
    type: ColType.SELECT,
    list: [],
    required: true
  },
  {
    title: 'Timeline',
    subtitle: 'Enter timeline',
    name: 'timeline',
    type: ColType.RANGE,
    required: true
  },
  {
    title: 'Total hours',
    subtitle: 'Enter number',
    name: 'dedication',
    type: ColType.INT,
    length: 100000,
    required: true
  },
  {
    title: 'Project role',
    subtitle: 'Enter role',
    name: 'ProjectRole_id',
    type: ColType.SELECT,
    list: [],
    required: true
  },
  {
    title: 'Offered hourly rate',
    subtitle: 'Enter number',
    name: 'offered',
    type: ColType.CURRENCY,
    required: true
  },
  {
    title: 'Cost hourly rate',
    subtitle: 'Enter number',
    name: 'cost',
    type: ColType.CURRENCY,
    required: true
  },
  {
    title: 'Information',
    subtitle: 'comment',
    name: 'description',
    type: ColType.AREA,
    length: 500,
    required: false,
    style: {
      width: '100%'
    }
  },
  {
    title: 'Status',
    subtitle: 'Enter status',
    name: 'status',
    type: ColType.RADIO,
    required: true,
    list: [
      {
        name: 'Active',
        id: ProjectAssignmentStatus.ACTIVE
      },
      {
        name: 'Pending',
        id: ProjectAssignmentStatus.PENDING
      },
      {
        name: 'Inactive',
        id: ProjectAssignmentStatus.INACTIVE
      }
    ]
  }
];
